/* fabri-envio.js — Bloque de confianza de envío por país.
   Datos generados desde fabri-envios/paises_envio.json. No editar a mano. */
(function () {
  'use strict';
  var LOGOS = {"yunexpress":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-yunexpress.png?v=1787167750","YunExpress"],"fpx":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-fpx.png?v=1787167751","4PX"],"cainiao":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-cainiao.png?v=1787167752","Cainiao"],"dhl":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-dhl.png?v=1787167754","DHL Express"],"usps":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-usps.png?v=1787167755","USPS"],"canadapost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-canadapost.png?v=1787167757","Canada Post"],"correosmx":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-correosmx.png?v=1787167758","Correos de México"],"correos":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-correos.png?v=1787167759","Correos"],"royalmail":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-royalmail.png?v=1787167760","Royal Mail"],"laposte":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-laposte.png?v=1787167762","La Poste"],"posteitaliane":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-posteitaliane.png?v=1787167763","Poste Italiane"],"deutschepost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-deutschepost.png?v=1787167764","Deutsche Post"],"postnl":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-postnl.png?v=1787167765","PostNL"],"bpost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-bpost.png?v=1787167766","bpost"],"postnord":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-postnord.png?v=1787167768","PostNord"],"swisspost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-swisspost.png?v=1787167768","Swiss Post"],"anpost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-anpost.png?v=1787167769","An Post"],"ctt":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-ctt.png?v=1787167771","CTT"],"correoarg":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-correoarg.png?v=1787167772","Correo Argentino"],"correios":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-correios.png?v=1787167773","Correios"],"auspost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-auspost.png?v=1787167774","Australia Post"],"nzpost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-nzpost.png?v=1787167776","NZ Post"],"shalom":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-shalom.png?v=1787167777","Shalom"],"olva":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-olva.png?v=1787167778","Olva Courier"],"serpost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-serpost.png?v=1787167779","Serpost"],"correoscl":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-correoscl.png?v=1787167781","Correos de Chile"],"servientrega":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-servientrega.png?v=1787167782","Servientrega"],"inposdom":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-inposdom.png?v=1787167783","INPOSDOM"],"correoscr":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-correoscr.png?v=1787167785","Correos de Costa Rica"],"emiratespost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-emiratespost.png?v=1787167786","Emirates Post"],"israelpost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-israelpost.png?v=1787167787","Israel Post"],"inpost":["https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-car-inpost.png?v=1787167788","InPost"]};
  var PAISES = {"US":{"es":"Estados Unidos","en":"United States","lg":["usps"],"nm":null,"d1":10,"d2":18,"ad":"ddp"},"CA":{"es":"Canadá","en":"Canada","lg":["canadapost"],"nm":null,"d1":9,"d2":16,"ad":"normal"},"MX":{"es":"México","en":"Mexico","lg":["correosmx"],"nm":null,"d1":13,"d2":20,"ad":"normal"},"ES":{"es":"España","en":"Spain","lg":["correos"],"nm":null,"d1":11,"d2":20,"ad":"normal"},"DE":{"es":"Alemania","en":"Germany","lg":["deutschepost"],"nm":null,"d1":11,"d2":18,"ad":"normal"},"FR":{"es":"Francia","en":"France","lg":["laposte"],"nm":null,"d1":12,"d2":22,"ad":"normal"},"IT":{"es":"Italia","en":"Italy","lg":["posteitaliane"],"nm":null,"d1":10,"d2":18,"ad":"normal"},"GB":{"es":"Reino Unido","en":"United Kingdom","lg":["royalmail"],"nm":null,"d1":9,"d2":15,"ad":"normal"},"NL":{"es":"Países Bajos","en":"Netherlands","lg":["postnl"],"nm":null,"d1":11,"d2":17,"ad":"normal"},"PT":{"es":"Portugal","en":"Portugal","lg":["ctt"],"nm":null,"d1":12,"d2":19,"ad":"normal"},"PL":{"es":"Polonia","en":"Poland","lg":["inpost"],"nm":null,"d1":10,"d2":16,"ad":"normal"},"BE":{"es":"Bélgica","en":"Belgium","lg":["bpost"],"nm":null,"d1":9,"d2":18,"ad":"normal"},"SE":{"es":"Suecia","en":"Sweden","lg":["postnord"],"nm":null,"d1":12,"d2":19,"ad":"normal"},"DK":{"es":"Dinamarca","en":"Denmark","lg":["postnord"],"nm":null,"d1":12,"d2":19,"ad":"normal"},"IE":{"es":"Irlanda","en":"Ireland","lg":["anpost"],"nm":null,"d1":12,"d2":19,"ad":"normal"},"AT":{"es":"Austria","en":"Austria","lg":["deutschepost"],"nm":null,"d1":12,"d2":18,"ad":"normal"},"CH":{"es":"Suiza","en":"Switzerland","lg":["swisspost"],"nm":null,"d1":7,"d2":12,"ad":"normal"},"CZ":{"es":"Chequia","en":"Czechia","lg":[],"nm":"Česká pošta","d1":12,"d2":20,"ad":"normal"},"PE":{"es":"Perú","en":"Peru","lg":["shalom","olva","serpost"],"nm":null,"d1":2,"d2":7,"ad":"libre","intl":[],"intlnm":{"es":"Stock en Perú","en":"Stock in Peru"},"mes":"Enviamos desde nuestro stock en Perú: sin aduana y sin ningún costo extra, compres la cantidad que compres.","men":"Shipped from our stock in Peru: no customs and no extra cost at all, whatever quantity you buy."},"CO":{"es":"Colombia","en":"Colombia","lg":["servientrega"],"nm":null,"d1":16,"d2":24,"ad":"normal"},"CL":{"es":"Chile","en":"Chile","lg":["correoscl"],"nm":null,"d1":15,"d2":24,"ad":"normal"},"AR":{"es":"Argentina","en":"Argentina","lg":["correoarg"],"nm":null,"d1":24,"d2":30,"ad":"normal"},"EC":{"es":"Ecuador","en":"Ecuador","lg":["dhl","servientrega"],"nm":null,"d1":16,"d2":26,"ad":"normal"},"BR":{"es":"Brasil","en":"Brazil","lg":["correios"],"nm":null,"d1":17,"d2":30,"ad":"normal"},"UY":{"es":"Uruguay","en":"Uruguay","lg":[],"nm":"Correo Uruguayo","d1":16,"d2":26,"ad":"normal"},"GT":{"es":"Guatemala","en":"Guatemala","lg":["dhl"],"nm":null,"d1":15,"d2":30,"ad":"normal"},"CR":{"es":"Costa Rica","en":"Costa Rica","lg":["correoscr"],"nm":null,"d1":15,"d2":30,"ad":"normal"},"PA":{"es":"Panamá","en":"Panama","lg":["dhl"],"nm":null,"d1":14,"d2":26,"ad":"normal"},"DO":{"es":"Rep. Dominicana","en":"Dominican Republic","lg":["inposdom"],"nm":null,"d1":15,"d2":28,"ad":"libre","lim":200},"AU":{"es":"Australia","en":"Australia","lg":["auspost"],"nm":null,"d1":12,"d2":21,"ad":"libre","lim":650},"NZ":{"es":"Nueva Zelanda","en":"New Zealand","lg":["nzpost"],"nm":null,"d1":12,"d2":21,"ad":"libre","lim":600},"IL":{"es":"Israel","en":"Israel","lg":["israelpost"],"nm":null,"d1":12,"d2":22,"ad":"normal"},"ZA":{"es":"Sudáfrica","en":"South Africa","lg":[],"nm":"SA Post Office","d1":16,"d2":27,"ad":"normal"},"AE":{"es":"Emiratos Árabes","en":"UAE","lg":["emiratespost"],"nm":null,"d1":12,"d2":20,"ad":"normal"},"KR":{"es":"Corea del Sur","en":"South Korea","lg":["fpx"],"nm":null,"d1":12,"d2":20,"ad":"normal"},"JP":{"es":"Japón","en":"Japan","lg":["fpx"],"nm":null,"d1":10,"d2":18,"ad":"normal"},"XX":{"es":"Otro país","en":"Other country","lg":[],"nm":null,"d1":12,"d2":25,"ad":"normal"}};
  var ICO = 'https://cdn.shopify.com/s/files/1/0714/7615/0510/t/10/assets/fabri-ico-';
  var GEO = 'https://geo.fabricreator.com';

  var T = {
    es: {
      envio: 'Envío a', gratis: 'GRATIS',
      fecha: function (a, b) { return 'Llega entre el <b>' + a + '</b> y el <b>' + b + '</b>'; },
      fine: 'Impuestos de importación no incluidos. Se pagan al recibir el pedido.',
      libre: 'Llega sin impuestos de importación. No pagas nada extra al recibir.',
      ddp: 'Los aranceles ya están incluidos. No pagas nada extra al recibir.',
      ver: 'Ver detalles', ocultar: 'Ocultar',
      exp: 'El precio incluye el envío, pero no los impuestos de importación de tu país (en comercio internacional esto se llama DAP, antes DDU). Cuando el paquete llega, la aduana o el transportista pueden cobrar arancel, IVA y un pequeño cargo de gestión; el importe lo fija tu país, no nosotros, y depende del destino y del valor del pedido. Si quieres una estimación antes de comprar, <a href="https://wa.me/51990996163" target="_blank" rel="noopener">escríbenos por WhatsApp</a>.',
      seg: 'Seguimiento incluido', pol: 'Política de envíos',
      // invisible: deja constancia del uso informativo sin ocupar espacio
      ruta: 'Transportistas que realizan la entrega. Los logos son de sus respectivos titulares y se muestran solo a modo informativo.',
      local: 'correo de tu país', intl: 'YunExpress'
    },
    en: {
      envio: 'Shipping to', gratis: 'FREE',
      fecha: function (a, b) { return 'Arrives between <b>' + a + '</b> and <b>' + b + '</b>'; },
      fine: 'Import duties and taxes not included. Payable on delivery in your country.',
      libre: 'Arrives with no import duties. Nothing extra to pay on delivery.',
      ddp: 'Import duties are already covered. Nothing extra to pay on delivery.',
      ver: 'See details', ocultar: 'Hide',
      exp: 'The price includes shipping, but not your country\'s import taxes (the trade term is DAP, formerly DDU). When the parcel arrives, customs or the courier may charge duty, VAT and a small handling fee; the amount is set by your country, not by us, and depends on the destination and the order value. Want an estimate before you buy? <a href="https://wa.me/51990996163" target="_blank" rel="noopener">Message us on WhatsApp</a>.',
      seg: 'Tracking included', pol: 'Shipping policy',
      ruta: 'Carriers delivering your order. Logos belong to their respective owners and are shown for information purposes only.',
      local: 'your national postal service', intl: 'YunExpress'
    }
  };

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function icono(n, cls) {
    return '<span class="fbe-ico' + (cls || '') + '"><img src="' + ICO + n + '.svg" alt="" loading="lazy"></span>';
  }
  function logo(k) {
    var L = LOGOS[k];
    return L ? '<img class="fbe-car" src="' + L[0] + '" alt="' + esc(L[1]) + '" title="' + esc(L[1]) + '" loading="lazy">' : '';
  }
  function grupo(claves, alterno) {
    var s = (claves || []).map(logo).join('');
    return s ? '<span class="fbe-grupo">' + s + '</span>'
             : '<span class="fbe-word">' + esc(alterno) + '</span>';
  }
  function habiles(n) {
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmt(d, lang) {
    try { return d.toLocaleDateString(lang === 'en' ? 'en-US' : 'es-PE', { day: 'numeric', month: 'short' }); }
    catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }

  function pinta(caja) {
    var iso = (caja.getAttribute('data-iso') || 'XX').toUpperCase();
    var p = PAISES[iso] || PAISES.XX;
    var lang = caja.getAttribute('data-lang') === 'en' ? 'en' : 'es';
    var t = T[lang];
    var total = parseFloat(caja.getAttribute('data-total')) || 0;
    var abierto = caja.getAttribute('data-open') === '1';

    // La línea positiva solo se muestra si es CIERTA para este carrito.
    var nivel = p.ad;
    if (nivel === 'libre' && p.lim && total > p.lim) nivel = 'normal';

    var aviso;
    if (nivel === 'ddp' || nivel === 'libre') {
      var msg = p['m' + lang] || (nivel === 'ddp' ? t.ddp : t.libre);
      aviso = '<div class="fbe-fila pos">' + icono('check') + '<span>' + msg + '</span></div>';
    } else {
      aviso = '<div class="fbe-fine">' + t.fine +
        ' <button type="button" data-fbe-tog>' + (abierto ? t.ocultar : t.ver) + '</button></div>' +
        (abierto ? '<div class="fbe-exp">' + t.exp + '</div>' : '');
    }

    var intlClaves = p.intl !== undefined ? p.intl : ['yunexpress'];
    var intlNombre = p.intlnm ? p.intlnm[lang] : t.intl;
    var tramo = grupo(intlClaves, intlNombre) + '<span class="fbe-sep"></span>';

    var bandera = iso === 'XX'
      ? icono('globo')
      : '<img class="fbe-flag" src="https://flagcdn.com/64x48/' + iso.toLowerCase() + '.png" alt="" loading="lazy">';

    var cabecera = '<div class="fbe-head">' + bandera +
      '<span class="fbe-title">' + t.envio + ' ' + esc(p[lang]) +
      ' — <span class="fbe-gratis">' + t.gratis + '</span></span></div>';
    var fecha = '<div class="fbe-fila">' + icono('calendario') + '<span>' +
      t.fecha(fmt(habiles(p.d1), lang), fmt(habiles(p.d2), lang)) + '</span></div>';
    var transportistas = tramo + grupo(p.lg, p.nm || t.local);

    if (caja.getAttribute('data-ctx') === 'cart') {
      // EN EL CARRITO VA COMPACTO. El panel lateral reparte una altura fija entre la
      // lista de productos y el resumen, y la lista es la que cede: un bloque alto
      // aqui aplasta el producto. Los logos suben a la misma linea del titulo y se
      // quita el pie, que en el carrito no aporta (el cliente ya vio la ficha).
      caja.innerHTML =
        '<div class="fbe-head" role="group" aria-label="' + esc(t.ruta) + '">' + bandera +
          '<span class="fbe-title">' + t.envio + ' ' + esc(p[lang]) +
          ' — <span class="fbe-gratis">' + t.gratis + '</span></span>' +
          '<span class="fbe-marcas">' + transportistas + '</span></div>' +
        fecha + aviso;
      return;
    }

    caja.innerHTML = cabecera +
      '<div class="fbe-ruta" role="group" aria-label="' + esc(t.ruta) + '">' +
        transportistas + '</div>' +
      fecha + aviso +
      '<div class="fbe-foot"><span>' + icono('escudo') + t.seg + '</span>' +
        '<a href="' + (caja.getAttribute('data-policy') || '/policies/shipping-policy') + '">' +
        icono('aduanas') + t.pol + '</a></div>';
  }

  // Un solo listener delegado: sobrevive al morphing del carrito.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fbe-tog]');
    if (!b) return;
    var caja = b.closest('[data-fbe]');
    if (!caja) return;
    e.preventDefault();
    caja.setAttribute('data-open', caja.getAttribute('data-open') === '1' ? '0' : '1');
    pinta(caja);
  });

  var geoPais = null, geoPedido = false;

  // Shopify guarda en la cookie "localization" el pais que vale para esta visita
  // (lo que el cliente eligio en el selector, o lo que Shopify le asigno).
  // Si existe, MANDA ELLA: no se puede pisar con la deteccion por IP, porque si no
  // el cliente elige Alemania y medio segundo despues le aparece Peru.
  function paisDeShopify() {
    var m = document.cookie.match(/(?:^|;)\s*localization=([^;]+)/);
    return m ? decodeURIComponent(m[1]).trim().toUpperCase() : null;
  }

  function pintaTodo() {
    var elegido = paisDeShopify();
    var cajas = document.querySelectorAll('[data-fbe]');
    for (var i = 0; i < cajas.length; i++) {
      var c = cajas[i];
      if (elegido) c.setAttribute('data-elegido', elegido);
      if (geoPais && !elegido && PAISES[geoPais]) c.setAttribute('data-iso', geoPais);
      if (c.getAttribute('data-pintado') !== '1' || c.getAttribute('data-forzar') === '1') {
        c.setAttribute('data-pintado', '1');
        c.removeAttribute('data-forzar');
        pinta(c);
      }
    }
    // Solo se consulta la IP cuando Shopify no dijo nada: primera visita sin cookie.
    if (!geoPedido && !elegido) {
      geoPedido = true;
      try {
        fetch(GEO, { mode: 'cors' })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d || !d.country || d.country === 'XX') return;
            if (paisDeShopify()) return;           // llego la cookie mientras tanto
            geoPais = d.country.toUpperCase();
            if (!PAISES[geoPais]) return;
            var cs = document.querySelectorAll('[data-fbe]');
            for (var j = 0; j < cs.length; j++) {
              if (cs[j].getAttribute('data-iso') === geoPais) continue;
              cs[j].setAttribute('data-iso', geoPais);
              pinta(cs[j]);
            }
          })
          .catch(function () { /* sin geo, se queda con el pais del tema */ });
      } catch (e) { /* navegador viejo */ }
    }
  }

  // ---- Productos MIXTOS (variantes fisicas y digitales en la misma ficha) ----
  // Los productos 100% digitales ni siquiera generan el bloque: eso lo resuelve
  // fabri-envio-info.liquid en el servidor, sin parpadeo. Esto es solo para el caso
  // mixto, donde el bloque debe aparecer o esconderse segun la variante elegida.
  function mapaVariantes(caja) {
    var s = caja.getAttribute('data-variantes');
    if (!s) return null;
    var m = {}, partes = s.split(',');
    for (var i = 0; i < partes.length; i++) {
      var p = partes[i].trim().split(':');
      if (p.length === 2) m[p[0]] = p[1] === '1';
    }
    return m;
  }

  function envioDeLaVarianteActual(mapa) {
    // 1) Horizon reescribe este JSON en cada cambio y ya trae requires_shipping
    var s = document.querySelector('variant-picker[data-template-product-match="true"] script[type="application/json"]');
    if (s && s.textContent) {
      try {
        var v = JSON.parse(s.textContent);
        if (v && typeof v.requires_shipping === 'boolean') return v.requires_shipping;
      } catch (e) { /* json roto: vamos al plan B */ }
    }
    // 2) Respaldo: el input oculto existe siempre, incluso sin variant-picker
    var inp = document.querySelector('form[action$="/cart/add"] input[name="id"]');
    if (inp && mapa && typeof mapa[String(inp.value)] === 'boolean') return mapa[String(inp.value)];
    return null;
  }

  // Idempotente a proposito: solo escribe si el DOM difiere, asi el
  // MutationObserver puede llamarla mil veces sin entrar en bucle.
  function ajustaDigitales() {
    var cajas = document.querySelectorAll('[data-fbe][data-ctx="product"][data-variantes]');
    for (var i = 0; i < cajas.length; i++) {
      var c = cajas[i];
      var envia = envioDeLaVarianteActual(mapaVariantes(c));
      if (envia === null) continue;
      var oculta = c.hasAttribute('hidden');
      if (envia && oculta) {
        c.removeAttribute('hidden');
        c.setAttribute('data-forzar', '1');
        pintaTodo();
      } else if (!envia && !oculta) {
        c.setAttribute('hidden', '');   // .fbe[hidden]{display:none} ya esta en el CSS
      }
    }
  }

  // En burbuja, NO en captura: asi el tema ya actualizo el input oculto.
  document.addEventListener('variant:update', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // fuera las tarjetas de recomendados y el quick-add, que emiten el mismo evento
    if (t.closest('product-card') || t.closest('quick-add-dialog') || t.closest('dialog')) return;
    if (t.getAttribute && t.getAttribute('data-template-product-match') !== 'true') return;
    ajustaDigitales();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { pintaTodo(); ajustaDigitales(); });
  } else {
    pintaTodo();
    ajustaDigitales();
  }
  // El drawer del carrito rehace el DOM: hay que volver a pintar.
  document.addEventListener('cart:update', pintaTodo);
  document.addEventListener('cart:refresh', pintaTodo);
  document.addEventListener('shopify:section:load', pintaTodo);
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { pintaTodo(); });
    var arranca = function () { mo.observe(document.body, { childList: true, subtree: true }); };
    if (document.body) arranca(); else document.addEventListener('DOMContentLoaded', arranca);
  }
})();
